import React from "react"
import { navigate } from "gatsby-link"

import pageTitleStyles from './page_titles.module.scss'
import tabbedStyles from './games_tabbed.module.scss'


import QbBoxSort from "./qb_box_sort"
import EraAdjElo from "./era_adj_elo"



const QbsTabbed = ({activeIndex}) => {

    const tabs = [
        {
            'index' : 0,
            'id' : 'ranks',
            'name' : 'Rankings',
            'component' : <QbBoxSort />,
            'route' : '/qb-rankings/',
        }, 
        {
            'index' : 1,
            'id' : 'era_adj_elo',
            'name' : 'Era Adjusted Elo',
            'component' : <EraAdjElo />,
            'route' : '/qb-rankings/era-adjusted/',
        }, 
    ]

    const tabToDisplay =  tabs[activeIndex]['component']

    return (
        <div className={pageTitleStyles.page_container}>
            <div className={pageTitleStyles.title_div}>
            <h2 className={pageTitleStyles.title_h2}>NFL QB Rankings</h2>
            <h3 className={pageTitleStyles.title_h3}>Through the most recent week</h3>
            </div>
            <div className={tabbedStyles.tab_container}>
                {tabs.map((item) => {
                    return (
                        <button
                            className={tabbedStyles.tab_button}
                            key={item.id}
                            onClick={()=> {navigate(item.route)}}
                            data-active={activeIndex===item.index ? true : false }
                        >
                            {item.name}
                        </button>
                    )
                })}
            </div>
            {tabToDisplay}
        </div>
    )
}

export default QbsTabbed